module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--claim-details"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--claim-details__box"
  }, [_c('div', {
    staticClass: "c-modal__box__header t-modal-header"
  }, [(_vm.type === 'approver') ? _c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.approver_header')))]) : _vm._e(), _vm._v(" "), (_vm.type === 'submitter') ? _c('h2', {
    staticClass: "c-modal__box__header__title t-modal-header__text"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.submitter_header')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__header__close"
  }, [_c('button', {
    staticClass: "c-modal__box__header__close__button t-modal-header__close",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__box__content"
  }, [(_vm.type === 'approver') ? _c('div', {
    staticClass: "c-modal--claim-details__headline"
  }, [_c('h1', {
    staticClass: "c-modal--claim-details__headline__claim-number"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_number', {
    claim_number: _vm.claim.record_number
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__headline__claim-status"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.claimStatusClass(_vm.claim)
  }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[_vm.claim.status])))])])]) : _c('div', {
    staticClass: "c-modal--claim-details__headline c-modal--claim-details__headline--submitter"
  }, [_c('h1', {
    staticClass: "c-modal--claim-details__headline__claim-number"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_number', {
    claim_number: _vm.claim.record_number
  })))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__headline__claim-status"
  }, [_c('span', {
    staticClass: "c-status",
    class: _vm.claimStatusClass(_vm.claim)
  }, [_vm._v(_vm._s(_vm.$t(_vm.CLAIM_STATUS_TRANSLATION[_vm.claim.status])))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__overview",
    class: [{
      'c-modal--claim-details__overview--submitter': _vm.type === 'submitter'
    }]
  }, [_c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_submitted')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_vm._v(_vm._s(_vm.claim.created_at))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_form_name')))]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_vm._v(_vm._s(_vm.claim.form_name))])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--claim-details__overview__dl"
  }, [_c('dt', {
    staticClass: "c-modal--claim-details__overview__dl__dt"
  }, [_vm._v("\n            " + _vm._s(_vm.type === 'approver' ? _vm.$t('web.claim_details_modal.claim_submitter') : _vm.$t('web.claim_details_modal.claim_approver')) + "\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "c-modal--claim-details__overview__dl__dd"
  }, [_c('span', [_vm._v(_vm._s(_vm.type === 'approver' ? _vm.claim.participant_name : _vm.claim.approver_name))]), _vm._v(" "), (_vm.type === 'submitter') ? _c('button', {
    staticClass: "c-modal--claim-details__overview--submitter__toggle-notes",
    on: {
      "click": function($event) {
        return _vm.toggleNotes()
      }
    }
  }, [_vm._v(_vm._s(_vm.notesMessage) + "\n            ")]) : _vm._e()])])]), _vm._v(" "), ((_vm.type === 'submitter')) ? _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes",
    class: [{
      'is-visible': _vm.showNotes
    }, {
      'is-hidden': !_vm.showNotes
    }]
  }, [(_vm.claim.approver_notes) ? _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes__bubble",
    domProps: {
      "innerHTML": _vm._s(_vm.formatNotes)
    }
  }) : _c('div', {
    staticClass: "c-modal--claim-details__submitter-view-notes__bubble"
  }, [_c('p', {
    staticClass: "c-modal--claim-details__notes-paragraph u-italic"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.no_approver_notes')))])])]) : _vm._e(), _vm._v(" "), (_vm.claim.field_defs) ? _c('div', {
    ref: "formDef",
    staticClass: "c-modal--claim-details__details"
  }, _vm._l((_vm.claim.field_defs), function(field, index) {
    return _c('fieldset', {
      key: index,
      staticClass: "o-fieldset c-modal--claim-details__details__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "template": _vm.type === 'submitter' && _vm.claim.status === _vm.CLAIM_STATUS.UPDATE_NEEDED ? 'edit' : 'detail',
        "labelClass": "c-modal--claim-details__details__fieldset__label"
      },
      model: {
        value: (_vm.claim.field_values[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.claim.field_values, field.name, $$v)
        },
        expression: "claim.field_values[field.name]"
      }
    }), _vm._v(" "), (_vm.errors[field.name]) ? _c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v("\n                  " + _vm._s(_vm.errors[field.name]) + "\n             ")]) : _vm._e()], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.type === 'approver') ? _c('div', {
    staticClass: "c-modal--claim-details__approver-view-notes"
  }, [_c('h2', {
    staticClass: "c-modal--claim-details__approver-view-notes__header"
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.claim_notes_label')))]), _vm._v(" "), (_vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('p', {
    staticClass: "c-modal--claim-details__approver-view-notes__desc"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.claim_notes_hint')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.claim.approver_notes),
      expression: "claim.approver_notes"
    }],
    staticClass: "o-textarea c-modal--claim-details__approver-view-notes__textarea",
    domProps: {
      "value": (_vm.claim.approver_notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.claim, "approver_notes", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.claim.approver_notes && _vm.claim.status !== _vm.CLAIM_STATUS.PENDING)) ? _c('div', {
    staticClass: "c-modal--claim-details__approver-view-notes__text",
    domProps: {
      "innerHTML": _vm._s(_vm.formatNotes)
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.type === 'approver' && _vm.claim.status === _vm.CLAIM_STATUS.PENDING) ? _c('div', {
    staticClass: "c-modal__box__actions"
  }, [_c('button', {
    staticClass: "c-modal__box__actions__button t-button-info",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.DECLINED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.decline_claim_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button t-button-danger",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.UPDATE_NEEDED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.update_needed_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-modal__box__actions__button t-button-success",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.approverUpdate(_vm.CLAIM_STATUS.APPROVED)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('web.claim_details_modal.approve_claim_button')) + "\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'submitter' && _vm.claim.status === _vm.CLAIM_STATUS.UPDATE_NEEDED) ? _c('div', {
    staticClass: "c-modal__box__actions c-modal--claim-details__box__actions"
  }, [_c('div', {
    staticClass: "c-modal--claim-details__box__actions__right"
  }, [_c('button', {
    ref: "cancelButton",
    staticClass: "c-modal__box__actions__button t-button-plain",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.cancel_submission_button')) + "\n        ")]), _vm._v(" "), _c('button', {
    ref: "submitButton",
    staticClass: "c-modal__box__actions__button c-modal--claim-details__submitter-submit-button t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.submit_updates_button')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--claim-details__box__actions__left"
  }, [_c('button', {
    ref: "withdrawButton",
    staticClass: "c-modal__box__actions__button t-button-danger",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": _vm.withdraw
    }
  }, [_vm._v(_vm._s(_vm.$t('web.claim_details_modal.withdraw_claim_button')) + "\n        ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f42d2144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/ClaimDetailsModal.vue
// module id = 568
// module chunks = 1